import { useMemo } from "react";
import { useSelector } from "react-redux";

const TIME_SPAN = 10 * 60 * 1000; // 10 Minutes

export default function useIsCardVisited() {
    const { visits } = useSelector(state => state.card_visit);

    const isCardVisited = (cardId) => {
        if (!cardId) return false;

        const visit = visits.find((visit) => visit.content_group_id === cardId);
        if (!visit) return false;

        return Date.now() - visit.updated_at_ms <= TIME_SPAN;
    };

  return {
    isCardVisited
  }
}
